export const Spinner = Vue.extend({
  props: {
    size: {
      // small | large
      type: String,
    },
    loadingText: {
      type: String,
    },
  },

  data() {
    return {
      opened: true,
    };
  },

  template: `
    <div class="spinner" :class="{ 'open': opened }">
      <div class="content">
        <svg class="spinner-inner spin" viewBox="0 0 50 50" :class='size'>
          <circle class="path" cx="25" cy="25" r="20"></circle>
        </svg>
        <div class="label" v-if='loadingText'>{{ loadingText }}</div>
      </div>
    </div>
  `,

  methods: {
    close() {
      this.opened = false;
      this.$emit('closed');
    },

    open() {
      if (this.opened) return;
      this.opened = true;
    },
  },
});

export const newSpinner = (settings = {}) => {
  const spinnerEl = Skylark.Helpers.Utilities.generateElement('div');
  const parentElement = settings.parent ? settings.parent : document.body;
  parentElement.appendChild(spinnerEl);
  return new Spinner({
    el: spinnerEl,
    propsData: settings,
  });
};

export default Spinner;
